module.exports = __webpack_public_path__ + "static/img/h3.7671f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h3.png
// module id = dv2q
// module chunks = 1